import React from "react";
import Modal from "../../common/Modal/Modal";
import "./nopropertiesselectedmodal.css"

/*
    Modal used when the user has not filled out compulsory values, 
    but is trying to generate a report
*/

export default function NoPropertiesSelectedModal({ isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={"No Properties Selected"}
      showCustomContent={true}
      customContent={
        <>
          {/* Error message originated from the submit completed modal */}
          <div className="noproperties-body">
            You have not selected any properties to merge with your form. Please
            select the properties you want to merge with your form.
          </div>
          <div>
            <div className="button-close-container">
              <button className="button-close" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </>
      }
    />
  );
}
